import axios from 'axios';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';





const UGC_PricingsModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);

    let initialData = {
        ExamType: 'Select exam type',
        TestCount: 0,
        Price: 0,
        Discount: 0,
        Sn: 0,
    }


    const [examBodyData, setExamBodyData] = useState(initialData);
    console.log(examBodyData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setExamBodyData(item)
            }
            setModalBox(true);

        }
    }));



    const hanldeSaveExamBody = async () => {
        try {
            if (examBodyData.ExamType.trim().length === 0 || examBodyData.ExamType === 'Select exam type') {
                toast.error("Please select exam type")
                return;
            } else if (examBodyData.TestCount <= 0) {
                toast.error("Please enter valid number of tests")
                return;
            } else if (examBodyData.Price <= 0) {
                toast.error("Please enter valid price")
                return;
            }
            const response = await axios.post(BACKEND_SERVER_URL + `${!examBodyData.Sn ? '/ugc/createPlan' : `/ugc/updatePlan`}`, examBodyData);
            toast.success(response.data.message);
        } catch (error) {
            console.log(error)
            toast.error(error?.response?.data?.message)
        } finally {
            props.setSubjectLoading(!props.loadSubjects);
            setExamBodyData(initialData)
            setModalBox(false);
        }

    }
    return (
        <>
            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> {examBodyData.Sn ? "Update Class" : "Upload Class"}</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="sessioncount" className="form-label text-primary">ExamType<span className="required">*</span></label>
                            <Select
                                value={{
                                    value: examBodyData.ExamType,
                                    label: examBodyData.ExamType === 'GENERAL APTITUDE' ? 'Teaching & Research Aptitude' : examBodyData.ExamType === 'SUBJECT SPECIFIC' ? 'Academic Subjects' : examBodyData.ExamType
                                }}
                                onChange={(selectedOption) => {
                                    setExamBodyData({ ...examBodyData, ExamType: selectedOption.value })
                                }}
                                options={[
                                    { value: 'GENERAL APTITUDE', label: 'Teaching & Research Aptitude' },
                                    { value: 'SUBJECT SPECIFIC', label: 'Academic Subjects' },
                                    { value: 'COMBINED', label: 'COMBINED TESTS' }
                                ]}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '100%',
                                        backgroundColor: 'transparent', // Adjust as needed
                                        borderColor: '#17a2b8', // Adjust as needed

                                    }),
                                }}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">No. of Tests<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="number" name="" id="subjects" value={examBodyData.TestCount} onChange={(e) => setExamBodyData({ ...examBodyData, TestCount: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">Price<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="number" name="" id="subjects" value={examBodyData.Price} onChange={(e) => setExamBodyData({ ...examBodyData, Price: e.target.value })} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="subjects" className="form-label text-primary">Discount<span className="required">*</span></label>
                            <input autoFocus className='form-control' type="number" name="" id="subjects" value={examBodyData.Discount} onChange={(e) => setExamBodyData({ ...examBodyData, Discount: e.target.value })} />
                        </div>



                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs " onClick={hanldeSaveExamBody}>{examBodyData.Sn ? "Update" : "Upload "}</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default UGC_PricingsModal;